import { MatchDetailsData } from "@/pages/buddy/types/MatchDetailsData.ts";
import { FileData } from "@/pages/buddy/types/FileData.ts";
import {Characteristic} from "@/pages/buddy/types/Characteristic.ts";

export interface JobItem {
    is_gap: boolean;
    gap_reason?: string | null;
    title: string;
    company: string;
    start_date: string | null;
    end_date: string | null;
    responsibilities: string[];
    country: string | null;
    city: string | null;
    location_type: string | null;
    job_type: string | null;
}

export interface EducationItem {
    is_gap: boolean;
    gap_reason?: string | null;
    institution: string;
    degree: string;
    field_of_study: string;
    start_date: string | null;
    end_date: string | null;
    achievements: string[];
    country: string | null;
    city: string | null;
}

export interface CertificationItem {
    name: string;
    issuing_organization?: string | null;
    date_issued?: string | null;
    credential_id?: string | null;
    credential_url?: string | null;
}

export interface LanguageItem {
    language: string;
    level: string;
}

export interface CandidateDetailsData {
    p_id: string;
    is_active: boolean;
    first_name?: string | null;
    last_name?: string | null;
    address?: string | null;
    email?: string | null;
    phone?: string | null;
    country?: string | null;
    nationality?: string | null;
    linkedin_url?: string | null;
    github_url?: string | null;
    portfolio_url?: string | null;
    summary?: string | null;
    created_at: string | null;
    updated_at: string | null;
    skills: Characteristic[];
    technologies: Characteristic[];
    frameworks: Characteristic[];
    specializations: string[];
    job_history: JobItem[];
    education: EducationItem[];
    certifications: CertificationItem[];
    spoken_languages: Characteristic[];
    description: string | null;

    files: FileData[];

    matches: MatchDetailsData[];
    image_url?: string | null;

    job_history_processed_at: string | null;
    education_processed_at: string | null;

    llm_log?: ILLMLogEntry[];
    job_history_llm_log?: ILLMLogEntry[];
}

type FieldType = 'text' | 'date' | 'boolean' | 'array' | 'number';

interface FieldConfig {
    label: string;
    editable: boolean;
    type: FieldType;
    display?: boolean; // Whether to display this field
}

export const candidateFieldConfig: Record<keyof CandidateDetailsData, FieldConfig> = {
    p_id: { label: 'Candidate ID', editable: false, type: 'text', display: false },
    is_active: { label: 'Is Active', editable: true, type: 'boolean', display: true },
    first_name: { label: 'First Name', editable: true, type: 'text', display: true },
    last_name: { label: 'Last Name', editable: true, type: 'text', display: true },
    address: { label: 'Address', editable: true, type: 'text', display: true },
    email: { label: 'Email', editable: true, type: 'text', display: true },
    phone: { label: 'Phone', editable: true, type: 'text', display: true },
    country: { label: 'Country', editable: true, type: 'text', display: true },
    nationality: { label: 'Nationality', editable: true, type: 'text', display: true },
    linkedin_url: { label: 'LinkedIn URL', editable: true, type: 'text', display: true },
    github_url: { label: 'GitHub URL', editable: true, type: 'text', display: true },
    portfolio_url: { label: 'Portfolio URL', editable: true, type: 'text', display: true },
    summary: { label: 'Summary', editable: false, type: 'text', display: false },
    created_at: { label: 'Created At', editable: false, type: 'date', display: true },
    updated_at: { label: 'Updated At', editable: false, type: 'date', display: true },
    skills: { label: 'Skills', editable: false, type: 'array', display: false },
    technologies: { label: 'Technologies', editable: false, type: 'array', display: false },
    frameworks: { label: 'Frameworks', editable: false, type: 'array', display: false },
    specializations: { label: 'Specializations', editable: false, type: 'array', display: false },
    job_history: { label: 'Job History', editable: false, type: 'array', display: false },
    education: { label: 'Education', editable: false, type: 'array', display: false },
    certifications: { label: 'Certifications', editable: false, type: 'array', display: false },
    spoken_languages: { label: 'Spoken Languages', editable: false, type: 'array', display: false },
    matches: { label: 'Matches', editable: false, type: 'array', display: true },
    files: { label: 'Files', editable: false, type: 'array', display: false },
    image_url: { label: 'Image', editable: false, type: 'text', display: false },
    description: { label: 'Description', editable: false, type: 'text', display: false },
    job_history_processed_at: { label: 'Job History Processed At', editable: false, type: 'date', display: false },
    education_processed_at: { label: 'Education Processed At', editable: false, type: 'date', display: false },
    llm_log: { label: 'LLM Log', editable: false, type: 'array', display: false },
    job_history_llm_log: { label: 'LLM Log', editable: false, type: 'array', display: false },
};
